import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

export default function ScrollToTop() {
  const location = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === "POP") {
      // Back / Forward button → let browser restore scroll
      return;
    } else {
      // Normal link click → scroll to top
      window.scrollTo(0, 0);
    }
  }, [location, navigationType]);

  return null;
}